import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AIVideoHeaderProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  showBack?: boolean;
}

const AIVideoHeader: React.FC<AIVideoHeaderProps> = ({
  currentStep,
  totalSteps,
  onBack,
  showBack = true
}) => {
  return null;
};

export default AIVideoHeader;